module.exports = __webpack_public_path__ + "img/IN.15c43b4b.png";